export enum PaymentMethodToDisplay {
  ACH = 'ACH',
  EMPLOYEE_CARD = 'EMPLOYEE_CARD',
  OPS_CARD = 'OPS_CARD',
}
